import React, { useId, useState } from 'react'
import { ConfirmDialog } from '../../../../shared/sso-workspace/confirm-dialog'
import { serverMessage } from '../../../../shared/error/server-message'
import { useErrorLine } from '../../../../shared/error/use-error-line'
import { confirmMatches } from '../../../../shared/form/form-text-confirm'
import { deleteVersion } from './packages-api'

export const REASON_MAX = 500

// Typed confirmation, exactly as the server checks it: confirmMatches trims,
// but a version with a stray space typed is not the version, so the raw text
// must also be equal.
export const versionConfirmed = (typed, version) => typed === version && confirmMatches(typed, version, true)

export const DeleteVersionDialog = ({ open, packageName, channel, version, downloads, onCancel, onDeleted }) => {
  const ids = { confirm: useId(), reason: useId() }
  const [typed, setTyped] = useState('')
  const [reason, setReason] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, failure, setError] = useErrorLine()

  const cancel = () => { setError(null); setTyped(''); setReason(''); onCancel() }
  const remove = async () => {
    if (busy || !versionConfirmed(typed, version)) return
    setBusy(true)
    setError(null)
    try {
      await deleteVersion(packageName, channel, version, { confirm: typed, reason: reason.trim() })
      setBusy(false)
      onDeleted()
    } catch (err) {
      setBusy(false)
      setError(serverMessage(err, "The version couldn't be deleted."), err)
    }
  }

  const n = Number(downloads) || 0
  return (
    <ConfirmDialog open={open} title="Delete version"
      body={`Delete ${packageName} ${version} from ${channel}? It has been downloaded ${n} times. Projects that pin this version will fail to install on any machine that hasn't cached it. The file stays recoverable for 30 days. Type ${version} to confirm.`}
      confirmText="Delete version" confirmDisabled={!versionConfirmed(typed, version)} busy={busy} error={error} failure={failure}
      onConfirm={remove} onCancel={cancel}>
      <div className="mb-3">
        <label className="sw-label" htmlFor={ids.confirm}>Version</label>
        <input id={ids.confirm} className="form-control" autoComplete="off" value={typed} onChange={e => setTyped(e.target.value)} />
      </div>
      <div className="mb-3">
        <label className="sw-label" htmlFor={ids.reason}>Reason (optional)</label>
        <textarea id={ids.reason} className="form-control" rows={2} maxLength={REASON_MAX} value={reason} onChange={e => setReason(e.target.value)} />
      </div>
    </ConfirmDialog>
  )
}
